import { CONSTS } from "../../config/objectConst";
import { httpRequest } from "../httpRequest";

export const apiCampaign = {
  /** @deprecated Replace to RTK */
  updateCampaign: async ({ id, steps }) => {
    //let data = new FormData();
    //data.append("name", name);
    return await httpRequest({
      url: `${CONSTS.API.URL}campaigns/${id}/update_steps`,
      method: "PUT",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: { steps },
    });
  },
};
